<template>
  <div>
    <user-header v-if="isAuthenticated" />
    <guest-header v-if="!isAuthenticated" />
  </div>
</template>

<script>
import UserHeader from '@/components/Header/UserHeader/UserHeader'
import GuestHeader from '@/components/Header/GuestHeader/GuestHeader'

export default {
  name: 'Header',
  components: {
    UserHeader,
    GuestHeader
  }
}
</script>
